import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Select, Typography, DatePicker, Modal, Tooltip, Col, Row, Statistic, Progress, message, Spin } from 'antd'
import logo from '../../../../assets/images/vtrc-logo.png'
import { 
         setToken, 
         isLoggedIn, 
         getLsId, 
         checkLinkURL, 
         passwordEncrypt, 
         passwordDecrypt, 
         getOrganization,
         appVersion,
         userNameDecrypt
      } from '../../../../utils/auth'
import { apiKeyNews } from '../../../../utils/apiKey'
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";
import { Mutations, Queries } from '../../../../graphql'
import moment from 'moment'
// import { checkLinkURL, passwordEncrypt } from "../../../utils/auth";

const { Option } = Select;
const { Text, Title } = Typography
const { Countdown } = Statistic;

const { RangePicker } = DatePicker
const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
};

const testInfo = `<Row gutter={16} type="flex" justify="left" align="top" className="py-2">
      <Col md={24} className="mt-3">
            <b >Optional Password Policy: เป็นคำแนะนำ ไม่บังคับ</b><br></br>
            <p className='mb-1 mt-2'>
               <Icon 
                  type={this.state.checkPassword.step4 ? "check" : "close"} 
                  style={{ color: this.state.checkPassword.step4 ? "#02AE6D" : "#D94339" }} 
                  className="mr-2"
               /> 
               อักษรภาษาอังกฤษตัวพิมพ์ใหญ่ (A-Z) อย่างน้อย 1 ตัว
            </p>
            <p className='mb-1'>
               <Icon 
                  type={this.state.checkPassword.step5 ? "check" : "close"} 
                  style={{ color: this.state.checkPassword.step5 ? "#02AE6D" : "#D94339" }} 
                  className="mr-2"
               /> 
               ไม่ควรอักษรเรียง เช่น ABC, 123 หรือซ้ำ เช่น 111, AAA
            </p>
            <p className='mb-1'>
               <Icon 
                  type={this.state.checkPassword.step6 ? "check" : "close"} 
                  style={{ color: this.state.checkPassword.step6 ? "#02AE6D" : "#D94339" }} 
                  className="mr-2"
               /> 
               สัญลักษณ์พิเศษอย่างน้อย 1 ตัว (!@#S%^&*(_+?;))
            </p>
         </Col>
      </Row>`;
class ConfirmUser extends React.PureComponent {
	state = {
      loadingFullPage: false,
		checkPassword:{
         step1: false,
         step2: false,
         step3: false,
         step4: false,
         step5: false,
         step6: false
      },
      progressStep: 0,
      progressColor: "",
      passwordStrong: ""
	}

	handleSubmit = async e => {
		const { form, authLogin, propsClient } = this.props
      const { checkPassword } = this.state
      this.setState({
         loadingFullPage: true
      })
      
      if(
         form.getFieldValue('passwordCheck') &&
         form.getFieldValue('newpassword')
      ){
         form.validateFields(async (err, values) => {
            if (!err) {
               if(checkPassword.step1 && checkPassword.step2 && checkPassword.step3){
                  // console.log("client", client)
                  if(this.props.pageChangePassword == 'auth'){
                     try {
                        const API_DEVICE_KEY = atob(apiKeyNews())
                        const { data, errors } = await propsClient.mutate({
                           mutation: Mutations.login,
                           variables: {
                              lsid: getLsId(),
                              password: passwordDecrypt(),
                              appVersion: appVersion(),
                              apiKey: API_DEVICE_KEY,
                              organization: getOrganization(),
                              ssoId: userNameDecrypt()
                           }
                        })
               
                        console.log("datatest", data)
               
                        this.setState({
                           loadingFullPage: true
                        })
               
                        ////////////////////addmodalINTERNAL_SERVER_ERROR
                        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
                           await this.setState({
                              showModalErrors: true
                           })
                        }
                        if (data) {
                           // passwordEncrypt(password.password)
                           setToken(data.login, '1')
                           localStorage.setItem('sessionID', data.login.sessionID)
   
                           const DataFetchAPI = await axiosAPI.post(
                              `
                                 ${checkLinkURL()}SSOService/changePassword`,
                                 {
                                    username: userNameDecrypt(),
                                    sessionID: localStorage.getItem('sessionID'),
                                    appUsername: localStorage.getItem('appUsername'),
                                    newpassword: values.newpassword,
                                 },
                           );
            
                           if(DataFetchAPI.data.success){
   
                              this.props.onSwitchMainPage()
                              localStorage.setItem('expiredDate', "N")
                              message.success('ทำการตั้งรหัสผ่านใหม่เรียบร้อย')
                              passwordEncrypt(values.newpassword)
                              this.setState({
                                 loadingFullPage: false
                              })
            
                              if(authLogin){
                                 this.props.form.resetFields();
                              }
                           }else{
                              this.setState({
                                 loadingFullPage: false
                              })
                              message.error(DataFetchAPI.data.message)
                           }
                        }
                     } catch (error) {
                        this.setState({
                           loadingFullPage: false
                         })
   
                         message.error('รหัสผ่านไม่ถูกต้อง')
                        // console.log('error',error)
                        // message.error("รหัสบุคลากรไม่ถูกต้อง")
                        // const errorMessage = error.graphQLErrors[0].message
                        // message.error(ErrorMessageFormAPI(errorMessage))
                     }
                  }else{
                     try {
                        const DataFetchAPI = await axiosAPI.post(
                           `
                              ${checkLinkURL()}SSOService/createNewPassword`,
                              {
                                 username: this.props.dataProfileSSO.ssoId,
                                 // username: this.props.dataProfileSSO.empCode,
                                 newpassword: values.newpassword,
                                 idCardNo: this.props.otpToSead.citizenId,
                                 dob: this.props.otpToSead.birthDate
                              },
                        );
         
                        if(DataFetchAPI.data.success){
                           this.props.onSwitchMainPage()
                           localStorage.setItem('expiredDate', "N")
                           message.success('ทำการตั้งรหัสผ่านใหม่เรียบร้อย')
                           this.setState({
                              loadingFullPage: false
                           })
         
                           if(authLogin){
                              this.props.form.resetFields();
                           }
                        }else{
                           console.log('123123123')
                           this.setState({
                              loadingFullPage: false
                           })
                           message.error(DataFetchAPI.data.message)
                           // message.error('รหัส OTP ไม่ถูกต้อง')
                        }
                     } catch (error) {
                        this.setState({
                           loadingFullPage: false
                         })
   
                         message.error('รหัสผ่านไม่ถูกต้อง')
                        // console.log('error',error)
                        // message.error("รหัสบุคลากรไม่ถูกต้อง")
                        // const errorMessage = error.graphQLErrors[0].message
                        // message.error(ErrorMessageFormAPI(errorMessage))
                     }
                  } 
               }else{
                  // alert('0')
                  this.setState({
                     loadingFullPage: false
                  })
                  message.error('กรุณาตั้งรหัสผ่านตามเงื่อนไขที่กำหนด')
               }
             
            }else{
               this.setState({
                  loadingFullPage: false
               })
               message.error(err.newpassword.errors[0].message)
            }
         })
      }else{
         this.setState({
            loadingFullPage: false
         })
      }
      
	}

   validateToNextPassword = (rule, value, callback) => {
      const { form } = this.props;
      if(value.length >= 8){
         if (value && this.state.confirmDirty ) {
            form.validateFields(['newpassword'], { force: true });
         }
         callback();
      }else{
         callback('รหัสผ่านมีความยาวขั้นต่ำอย่างน้อย 8 ตัว');
      }
      
   };

   compareToFirstPassword = (rule, value, callback) => {
      const { form } = this.props;
      if(value.length >= 8){
         if (value && value !== form.getFieldValue('passwordCheck')) {
            callback('รหัสผ่านสองตัวที่คุณป้อนไม่สอดคล้องกัน!');
          } else {
            callback();
          }
      }else{
         callback('รหัสผ่านมีความยาวขั้นต่ำอย่างน้อย 8 ตัว');
      }
      
   };

   onCheckPasswordStep = (value) =>{
      let step1 = false
      let step2 = false
      let step3 = false
      let step4 = false
      let step5 = false
      let step6 = false
      console.log("this.isValidPassword(value)", this.isValidPassword(value))
      if(value.length >= 8){
         step1 = true
      }
      if(value.match(/([a-z])/)){
         step2 = true
      }
      if(value.match(/([0-9])/)){
         step3 = true
      }
      if(value.match(/([A-Z])/)){
         step4 = true
      }
      if(this.isValidPassword(value)){
         step5 = true
      }
      if(value.match(/.[!,@,#,$,%,^,&,*,?,_,~,:,;,<,>,+,{,},-,=,(,),',",\,/|]/)){
         step6 = true
      }

      let progressStep = 0
      let progressColor = ""
      let passwordStrong = ""
      if(step1 && step2 && step3 && step4 && step5 && step6){
         progressStep = 100
         progressColor = "#00B33D"
         passwordStrong = "strong"
      }else if(
         (step1 && step2 && step3 && step4) || 
         (step1 && step2 && step3 && step5) ||
         (step1 && step2 && step3 && step6)
      ){
         progressStep = 70
         progressColor = "#FFA800"
         passwordStrong = "medium"
      }else if(step1 && step2 && step3){
         progressStep = 33
         progressColor = "#AC0000"
         passwordStrong = "weak"
      }

      this.setState({
         checkPassword:{
            step1: step1,
            step2: step2,
            step3: step3,
            step4: step4,
            step5: step5,
            step6: step6,
         },
         progressStep: progressStep,
         progressColor: progressColor,
         passwordStrong: passwordStrong
      })
   }

   hasInvalidPatterns(password) {
      const invalidPattern = /(\w)\1{2,}/gm;
      return invalidPattern.test(password);
    }
    
   hasAscendingOrDescendingNumbers(password) {
      for (let i = 0; i < password.length - 2; i++) {
        if (this.isDigit(password[i]) && this.isDigit(password[i + 1]) && this.isDigit(password[i + 2])) {
          const first = parseInt(password[i], 10);
          const second = parseInt(password[i + 1], 10);
          const third = parseInt(password[i + 2], 10);
    
          if ((first + 1 === second && second + 1 === third) ||
            (first - 1 === second && second - 1 === third)) {
            return true;
          }
        }
      }
      return false;
    }
    
   isDigit(char) {
      return /^\d$/.test(char);
    }
    
   isValidPassword(password) {
      return !this.hasInvalidPatterns(password) && !this.hasAscendingOrDescendingNumbers(password);
   }
    

	render() {
		const { form, otpToSead, authLogin = false } = this.props

		return (
         <>
            <Spin spinning={this.state.loadingFullPage}>
               <Form>
                  {
                     !authLogin &&
                     <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 20 }}>
                        <img src={logo} alt="logo" className="logo-formlogin"  />
                     </div>
                  }
                  
                  <div style={{ textAlign: !authLogin ?  'center' : 'left' , marginTop: 10, marginBottom: 10 }}>
                     <Title 
                        level={3} 
                        style={{ marginBottom: '0' }}
                     >
                        ตั้งรหัสผ่านใหม่
                     </Title>
                  </div>
                  <Row gutter={16} type="flex" justify="left" align="top" className="py-2">
                     <Col md={24} className="">
                        <Form.Item label={"ตั้งรหัสผ่าน"} className="mb-0">
                           { this.props.form.getFieldDecorator("passwordCheck", {
                              rules:  [
                                 { 
                                    required: true, 
                                    message: 'กรุณากรอกระบุ ตั้งรหัสผ่าน',
                                 },
                                 {
                                    validator: this.validateToNextPassword,
                                 },
                           ],
                           })(
                              <Input.Password 
                                 className='block-news' 
                                 min={8}
                                 onChange={ (e) => this.onCheckPasswordStep(e.target.value) }
                              />
                           )}
                        </Form.Item>
                     </Col>
                     <Col md={24} className="">
                        <Form.Item label={"ยืนยันรหัสผ่าน"} className="mb-0">
                           { this.props.form.getFieldDecorator("newpassword", {
                              rules:  [
                                 { 
                                    required: true, 
                                    message: 'กรุณากรอกระบุ ยืนยันรหัสผ่าน',
                                 },
                                 {
                                    validator: this.compareToFirstPassword,
                                 },
                              ],
                           })(
                              <Input.Password 
                                 className='block-news' 
                                 onBlur={this.handleConfirmBlur}
                              />
                           )}
                        </Form.Item>
                     </Col>
                     <Col md={24} className="mt-3">
                        <Progress 
                           percent={this.state.progressStep} 
                           size="small" 
                           strokeColor={`${this.state.progressColor}`}
                        />
                        <p className='m-0'>
                           { this.state.passwordStrong }
                        </p>
                     </Col>
                     <Col md={24} className="mt-3">
                        <div>
                        <b>เงื่อนไขการตั้งรหัสผ่าน</b>
                        <Tooltip
                           placement="top"
                           overlayStyle={{maxWidth: '500px'}}
                           title={<div dangerouslySetInnerHTML={{ __html: testInfo }} />}
                        >
                           <Icon
                              type="info-circle"
                              className="ml-2"
                              style={{ color:"#1990ff" }}
                           />
                        </Tooltip>
                        </div>
                        <br></br>
                        <p className='mb-1 mt-2'>
                           { this.state.checkPassword.step1 }
                           <Icon 
                              type={this.state.checkPassword.step1 ? "check" : "close"} 
                              style={{ color: this.state.checkPassword.step1 ? "#02AE6D" : "#D94339" }} 
                              className="mr-2"
                           /> 
                              รหัสผ่านมีความยาวขั้นต่ำอย่างน้อย 8 ตัว
                        </p>
                        <p className='mb-1'>
                        { this.state.checkPassword.step2 }
                           <Icon 
                              type={this.state.checkPassword.step2 ? "check" : "close"} 
                              style={{ color: this.state.checkPassword.step2 ? "#02AE6D" : "#D94339" }} 
                              className="mr-2"
                           /> 
                              อักษรภาษาอังกฤษตัวพิมพ์เล็ก (a-z) อย่างน้อย 1 ตัว
                        </p>
                        <p className='mb-1'>
                           { this.state.checkPassword.step3 }
                           <Icon 
                              type={this.state.checkPassword.step3 ? "check" : "close"} 
                              style={{ color: this.state.checkPassword.step3 ? "#02AE6D" : "#D94339" }} 
                              className="mr-2"
                           /> 
                           ตัวเลข (0-9) อย่างน้อย 1 ตัว 
                        </p>
                     </Col>
                     {/* <Col md={24} className="mt-3">
                        <b >Optional Password Policy: เป็นคำแนะนำ ไม่บังคับ</b><br></br>
                        <p className='mb-1 mt-2'>
                           <Icon 
                              type={this.state.checkPassword.step4 ? "check" : "close"} 
                              style={{ color: this.state.checkPassword.step4 ? "#02AE6D" : "#D94339" }} 
                              className="mr-2"
                           /> 
                           อักษรภาษาอังกฤษตัวพิมพ์ใหญ่ (A-Z) อย่างน้อย 1 ตัว
                        </p>
                        <p className='mb-1'>
                           <Icon 
                              type={this.state.checkPassword.step5 ? "check" : "close"} 
                              style={{ color: this.state.checkPassword.step5 ? "#02AE6D" : "#D94339" }} 
                              className="mr-2"
                           /> 
                           ไม่ควรอักษรเรียง เช่น ABC, 123 หรือซ้ำ เช่น 111, AAA
                        </p>
                        <p className='mb-1'>
                           <Icon 
                              type={this.state.checkPassword.step6 ? "check" : "close"} 
                              style={{ color: this.state.checkPassword.step6 ? "#02AE6D" : "#D94339" }} 
                              className="mr-2"
                           /> 
                           สัญลักษณ์พิเศษอย่างน้อย 1 ตัว (!@#S%^&*(_+?;))
                        </p>
                     </Col> */}
                     <Col md={24} className="my-4" align="center">
                        <Button className='mr-md-1' type="primary btn-color-transparent btn-custom btn-cutom-width mb-2" htmlType="submit" onClick={this.handleSubmit} >
                           ยืนยัน
                        </Button>
                     </Col>
                  </Row>
               </Form>
            </Spin>
         </>
		)
	}
}

ConfirmUser.defaultProps = {
	autoFocus: false
}

ConfirmUser.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedConfirmUser = Form.create()(ConfirmUser)

export default WrappedConfirmUser
